/**
 * 企业组相关api
 */
import http from './http'

export default class DynamicApi {
    // 获取所在企业组信息
    static getGroupItem() {
        return http.httpGet('group');
    }

    // 创建企业组
    static createNew(name) {
        return http.httpGet('group/create', {name});
    }

    // 更换企业组
    static changeGroup(name) {
        return http.httpPost('group/change', {name});
    }

    // 根据名字查找相似企业组列表
    static getList(name) {
        return http.httpGet('group/list', {name});
    }

    // 获取组成员
    static getMember(pageSize) {
        return http.httpGet('group/users', {pageSize});
    }
}



// WEBPACK FOOTER //
// ./app/api/company.group.api.js